var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 328"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shadow",
    opacity: 0.5,
    cx: 11.5323,
    cy: 11.5323,
    r: 11.5323,
    fill: "#E7EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconDevice",
    d: "M13.685 6.91895H9.37961C8.87027 6.91895 8.45703 7.33864 8.45703 7.85594V15.9766C8.45703 16.4939 8.87027 16.9136 9.37961 16.9136H13.685C14.1943 16.9136 14.6076 16.4939 14.6076 15.9766V7.85594C14.6076 7.33864 14.1943 6.91895 13.685 6.91895ZM11.5323 16.2889C11.1921 16.2889 10.9172 16.0098 10.9172 15.6642C10.9172 15.3187 11.1921 15.0396 11.5323 15.0396C11.8725 15.0396 12.1474 15.3187 12.1474 15.6642C12.1474 16.0098 11.8725 16.2889 11.5323 16.2889Z",
    fill: "#83B8BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7589 2.30664C19.0613 2.30664 17.6836 3.68436 17.6836 5.38191C17.6836 7.07946 19.0613 8.45718 20.7589 8.45718C22.4564 8.45718 23.8341 7.07946 23.8341 5.38191C23.8341 3.68436 22.4564 2.30664 20.7589 2.30664ZM19.9255 6.7012L18.8214 5.59718C18.7015 5.47724 18.7015 5.2835 18.8214 5.16357C18.9414 5.04363 19.1351 5.04363 19.2551 5.16357L20.1438 6.04924L22.2596 3.93346C22.3795 3.81352 22.5733 3.81352 22.6932 3.93346C22.8131 4.05339 22.8131 4.24714 22.6932 4.36707L20.3591 6.7012C20.2422 6.82114 20.0454 6.82114 19.9255 6.7012Z",
    fill: "#05CD99"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevice);
export default __webpack_public_path__ + "static/media/iconDevice.c4a8107f86ceaa0156631fbda261a826.svg";
export { ForwardRef as ReactComponent };